import {
  Group,
  Title,
  Table,
  Box,
  NumberFormatter,
  Text,
  Badge,
} from "@mantine/core";
import {
  IconPhoto,
  IconTextScan2,
  IconVideo,
  IconVolume,
} from "@tabler/icons-react";
import { isUnavailable, lifecycleMeta, lifecycleOf } from "./modelLifecycle";

export default function ModelCardTooltip({ model }) {
  const sunset = model.sunsetAt ? new Date(model.sunsetAt) : null;
  const lifecycle = lifecycleMeta(model);
  return (
    <Box style={{ width: "300px" }} p="md">
      <Text fz="xs" tt="uppercase" fw={600} opacity={0.6}>
        Inference Model
      </Text>
      <Group justify="space-between">
        <Title order={4}>{model.name}</Title>
        {lifecycleOf(model) !== "active" && (
          <Badge size="sm" variant="light" color={lifecycle.color}>
            {lifecycle.label}
          </Badge>
        )}
      </Group>
      {sunset && (
        <Text fz="xs" c={isUnavailable(model) ? "dimmed" : "orange.4"}>
          {isUnavailable(model) ? "Retired" : "Sunsets"}{" "}
          {sunset.toLocaleDateString()}
        </Text>
      )}
      <Table striped={false} withRowBorders={false} fz="sm">
        <Table.Thead>
          <Table.Tr>
            <Table.Th></Table.Th>
            <Table.Th ta="right">Input</Table.Th>
            <Table.Th ta="right">Output</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {model.pricingGraduations.map((graduation) => (
            <Table.Tr key={graduation.fromPromptLength}>
              <Table.Td ta="right">
                {graduation.fromPromptLength > 0 && (
                  <NumberFormatter
                    thousandSeparator
                    value={graduation.fromPromptLength}
                  />
                )}
              </Table.Td>
              <Table.Td ta="right">
                <NumberFormatter
                  prefix="$ "
                  decimalScale={2}
                  fixedDecimalScale
                  value={graduation.input}
                />
              </Table.Td>
              <Table.Td ta="right">
                <NumberFormatter
                  prefix="$ "
                  decimalScale={2}
                  fixedDecimalScale
                  value={graduation.output}
                />
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
      {model.inputModalities.length > 0 && (
        <>
          <Text fz="sm" fw={600} mt="xs">
            Supported Modalities
          </Text>
          <Group justify="space-between" wrap="wrap">
            Input:
            <Group>
              {model.inputModalities.includes("text") && <IconTextScan2 />}
              {model.inputModalities.includes("image") && <IconPhoto />}
              {model.inputModalities.includes("audio") && <IconVolume />}
              {model.inputModalities.includes("video") && <IconVideo />}
            </Group>
          </Group>
          <Group mt="xs" justify="space-between">
            Output:
            <Group>
              {model.outputModalities.includes("text") && <IconTextScan2 />}
              {model.outputModalities.includes("image") && <IconPhoto />}
              {model.outputModalities.includes("audio") && <IconVolume />}
              {model.outputModalities.includes("video") && <IconVideo />}
            </Group>
          </Group>
        </>
      )}
      {model.maxInputTokens > 0 && model.maxOutputTokens > 0 && (
        <>
          <Text fz="sm" fw={600} mt="xs">
            Max Token Counts
          </Text>
          Input:{" "}
          <NumberFormatter
            value={model.maxInputTokens}
            thousandSeparator
            decimalScale={0}
          />
          <br />
          Output:{" "}
          <NumberFormatter
            value={model.maxOutputTokens}
            thousandSeparator
            decimalScale={0}
          />
        </>
      )}
    </Box>
  );
}
